// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"10428":"2fbd01f331486bf7","72107":"5fbb4419319de091","76020":"d304e2c8c17e3693","90297":"5d06d83db73c3920"}[chunkId] + ".css";
};